<a
  class="skip-to-content screenreader-only"
  href="#main-content"
  (click)="skipToMainContent($event)"
>
  {{ 'general.skipToContent' | translate }}
</a>

<bdo-minimal-header class="header"></bdo-minimal-header>

<main id="main-content" class="main-content" tabindex="-1">
  <router-outlet>
    @if (isNavigating) {
      <bdo-loading [fullscreen]=true></bdo-loading>
    }
    <bdo-breadcrumb class="re-mb-30 re-block"></bdo-breadcrumb>
    <bdo-hotline-slide-over></bdo-hotline-slide-over>
  </router-outlet>
</main>

<bdo-svg-definitions></bdo-svg-definitions>

<bdo-minimal-footer></bdo-minimal-footer>

<bdo-maintenance-warning
  [infoText]="(maintenanceData$ | async)?.infotext"
  [start]="(maintenanceData$ | async)?.start"
  [end]="(maintenanceData$ | async)?.end"
  [soonUnderMaintenance]="(maintenanceStatus$ | async) === BackendStatus.SoonUnderMaintenance"
></bdo-maintenance-warning>

@if (campaignPopupIsReadyToShow$ | async) {
  <bdo-campaign-popup
    [popupIsReadyToShow$]="campaignPopupIsReadyToShow$"
    [campaign]="campaignService.currentCampaign$ | async"
  ></bdo-campaign-popup>
}


@if (popupsAreReadyToShow$ | async) {
  <bdo-opt-in-popup
    [popupIsReadyToShow]="popupsAreReadyToShow$ | async"
    [currentCampaign]="campaignService.currentCampaign$ | async"
    [hasNoCampaigns]="campaignService.hasNoCampaigns$ | async"
    />
}

<bdo-online-service-removed-message
  [readonlyHasStarted]="false"
  [showMessage]="showOnlineServiceRemovedMessage$ | async"
  (closeMessage)="onCloseOnlineServiceRemovedMessage()"
></bdo-online-service-removed-message>

@if (toastService.currentToast()) {
  <bdo-toast-notification
  ></bdo-toast-notification>
}
